var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dropdown',{attrs:{"prefix":_vm.prefix,"items":[
        { key: '', value: 'All Time' },
        { key: 'today', value: 'Today' },
        { key: 'yesterday', value: 'Yesterday' },
        { key: 'last7days', value: 'Last 7 Days' },
        { key: 'last4weeks', value: 'Last 4 Weeks' } ],"selected":_vm.timeframe},on:{"change":function($event){return _vm.$emit('change', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }